// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip--1fk6s","icon-question-sign":"icon-question-sign--1170Q","arrow-left":"arrow-left--2YnyX","inner-arrow":"inner-arrow--2Yo3P","tip":"tip--2WLBf","title":"title--3s6YV","content":"content--3g1gg","show":"show--t7vAg"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/ToolTip/index.scss
 ** module id = 236
 ** module chunks = 3 12 13 14
 **/